module.exports = __webpack_public_path__ + "static/media/pres_pgs09.c950a8ad.png";